import { createSlice } from '@reduxjs/toolkit'
import {
  getFlightTypes,
  getAirlineConfigurations,
  addAirlineConfiguration,
  removeAirlineConfiguration,
  addFlightType,
} from './thunks'

const initialState = {
  flightTypes: [],
  configurations: [],
  status: 'idle',
  error: null,
}

export const airlineConfigSlice = createSlice({
  name: 'airlineConfig',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Flight Types
    builder.addCase(getFlightTypes.pending, (state) => {
      state.status = 'loading'
    })
    builder.addCase(getFlightTypes.fulfilled, (state, action) => {
      state.flightTypes = action.payload || []
      state.status = 'successful'
    })
    builder.addCase(getFlightTypes.rejected, (state, action) => {
      state.status = 'failed'
      state.error = action.payload?.error
    })

    // Airline Configurations
    builder.addCase(getAirlineConfigurations.fulfilled, (state, action) => {
      state.configurations = action.payload || []
    })

    // Add Configuration
    builder.addCase(addAirlineConfiguration.fulfilled, (state, action) => {
      if (action.payload) {
        state.configurations.push(action.payload)
      }
    })

    // Remove Configuration
    builder.addCase(removeAirlineConfiguration.fulfilled, (state, action) => {
      state.configurations = state.configurations.filter(c => c.id !== action.payload)
    })

    // Add Flight Type
    builder.addCase(addFlightType.fulfilled, (state, action) => {
      if (action.payload) {
        state.flightTypes.push(action.payload)
      }
    })
  }
})

export default airlineConfigSlice.reducer
